import React from "react";
import Modal from "../modal/modal";
import {SiMicrosoftexcel} from "react-icons/si";

const UploadModal = ({openModal,closeModalHandler,handleSubmit,fileName,fileChangeHandler,getTemplateDownload,loaded})=>{
    return (
        <Modal
            open={openModal}
            maxWidth={true}
            handleClose={closeModalHandler}
        >
            <form onSubmit={handleSubmit} className="space-y-2">
                <div className="space-y-2">
                    <p className="block m-0 text-sm font-medium leading-6 text-gray-900">
                        File name
                    </p>
                    <div className="h-10 p-2 border border-gray-300 rounded-md">
                        {fileName}
                    </div>
                </div>
                <div>
                    <label
                        htmlFor="file-upload"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Choose a file
                    </label>
                    <div
                        className="flex justify-center px-6 py-10 mt-2 border border-dashed rounded-lg border-gray-900/25">
                        <div className="text-center">
                            <SiMicrosoftexcel
                                className="w-12 h-12 mx-auto text-neutral-500 "
                                aria-hidden="true"
                            />
                            <div className="flex mt-2 text-sm leading-6 text-gray-600">
                                <label
                                    htmlFor="file-upload"
                                    className="relative font-semibold text-indigo-600 bg-white rounded-md cursor-pointer focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                >
                                    <span>Upload a file</span>
                                    <input
                                        onChange={fileChangeHandler}
                                        id="file-upload"
                                        name="file-upload"
                                        type="file"
                                        className="sr-only"
                                        required
                                    />
                                </label>
                                <p className="pl-1 m-0">or drag and drop</p>
                            </div>
                            <p className="text-xs leading-5 text-gray-600">
                                PNG, JPG, GIF up to 10MB
                            </p>
                        </div>
                    </div>
                </div>
                <div>
                    <span className="font-medium">Template:</span>
                    <button onClick={getTemplateDownload} className="ml-1 font-medium text-indigo-600" type="button">
                        Download
                    </button>
                </div>
                {loaded > 0 && (
                    <div className="h-8 border rounded-md border-neutral-200">
                        <div
                            style={{
                                width: `${loaded}%`,
                                height: "100%",
                            }}
                            className={
                                "text-white font-medium rounded-md flex items-center pl-2 bg-green-500"
                            }
                        >
                            {loaded}%
                        </div>
                    </div>
                )}
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={closeModalHandler}
                        className="px-8 py-1 font-medium text-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-600 hover:text-white"
                        type="button"
                    >
                        Cancel
                    </button>
                    <button
                        className="px-8 py-1 font-medium text-indigo-600 border border-indigo-600 rounded-md hover:bg-indigo-600 hover:text-white"
                        type="submit"
                    >
                        Send
                    </button>
                </div>
            </form>
        </Modal>
    )
}

export default UploadModal